// Color theme preference for nihi-themed sites (nihirote.surf).
// Default is dark (studio palette + brand typography). Light is the sand/brass
// resort palette (body.nihi-light). Persisted in localStorage; chadha builds
// never enable this (SITE.theme !== 'nihi').
import { useSyncExternalStore } from 'react';
import SITE from './site';

const KEY = 'nihi-color-theme'; // 'dark' | 'light'
const listeners = new Set();

function read() {
  if (SITE.theme !== 'nihi') return 'dark';
  try {
    return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
}

export function getNihiColorTheme() {
  return read();
}

export function setNihiColorTheme(theme) {
  if (SITE.theme !== 'nihi') return;
  const next = theme === 'light' ? 'light' : 'dark';
  try {
    localStorage.setItem(KEY, next);
  } catch {
    /* private mode */
  }
  listeners.forEach((l) => l());
}

export function useNihiColorTheme() {
  const theme = useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    read,
    () => 'dark'
  );
  return {
    enabled: SITE.theme === 'nihi',
    theme,
    setTheme: setNihiColorTheme,
    toggle: () => setNihiColorTheme(theme === 'light' ? 'dark' : 'light'),
  };
}
